module.exports = __webpack_public_path__ + "img/wlyc.1bd1c5c9.jpg";